var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.filteredItems,"menu-props":{offsetY: true },"item-text":"isim","item-value":"id","label":"Tahsilat Alt Türü","outlined":"","dense":""},on:{"input":_vm.input},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }